export default __webpack_public_path__ + "static/media/settings.874ecb61.png";